/**
 * GTranslate Cleanup - MutationObserver Method
 * Prevents the top bar from rendering and cleans up ARIA for Lighthouse
 */
const translateObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            // 1. Intercept and kill the dynamic CSS that pushes the body down
            if (node.tagName === 'STYLE' && node.innerHTML.includes('goog-te-banner')) {
                node.remove();
            }

            // 2. Intercept and kill the iframe/toolbar before it becomes visible
            if (node.classList && (node.classList.contains('skiptranslate') || node.id?.includes('goog-gt-tt'))) {
                // Instead of removing (which can break the JS), we neutralize it
                node.setAttribute('title', 'Google Translate');
                node.setAttribute('aria-hidden', 'true');
                node.setAttribute('tabindex', '-1');
            }
        });
    });
});

translateObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
});

document.addEventListener("dragstart", (e) => {
    if (e.target.matches("button")) {
        e.preventDefault();
    }
});

import GM_Helper from './gm-helper.js';
GM_Helper.init();
import './accordion.js';
import './tabs.js';
import './header.js';
import './featured-services.js';
import './carousel.js';
import './logotypes.js';
import './floating-contact.js';
import './contact-form.js';
import './blog.js';
import './back-to-top.js';